define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/xml"
], function(declare,Action,xml) {

	return declare(Action, {
		isToggledInitially: function(/*csi.def.Context*/ctx) {
			// summary: determine if action should be in toggled state initially
			return xml.nodeAttributeHasFlag(ctx.getNode(), "DefaultQuote", xml.ATTR_FLAG_NOEDIT);
		},
		
		hasAccess: function(/*csi.def.Context*/ctx) {
			// summary: only allow rule if ProductionQuote is valid
			return this.inherited(arguments) && xml.isValidURL(ctx.getNode().DefaultQuote);
		}
	});
});